var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn",class:_vm.btnClasses,attrs:{"type":_vm.type,"title":_vm.title},on:{"click":_vm.onEmit}},[(_vm.icon)?_c('i',{staticClass:"text-primary",class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }